import React from 'react';
import TourSelectorPanel from './TourSelectorPanel';
import ZoneControlsPanel from './ZoneControlsPanel';

export default function MapLayersPanel() {
  return (
    <div className="d-flex flex-column gap-3">
      <TourSelectorPanel />
      <ZoneControlsPanel />
    </div>
  );
}
